/**
 * ProcessingModal.tsx
 * 
 * 処理中を示すモーダルコンポーネント
 * 
 * 【特徴】
 * - ユーザー操作による閉じる操作を完全に無効化
 * - プログラムによる制御のみで開閉
 * - MessageDialogと異なり、閉じるボタンなし
 * 
 * 【使用場面】
 * - PDF→PNG変換処理中
 * - ファイルアップロード処理中
 * - その他の長時間処理中
 * 
 * 【MessageDialogとの違い】
 * - MessageDialog: ユーザーが閉じるボタンで閉じる（hasButton=true時）
 * - ProcessingModal: プログラムでのみ制御（hasButton=false時）
 */
import React from "react";

import {
    Dialog,
    DialogContent,
    DialogContentText,
} from '@mui/material';

/**
 * ProcessingModalのプロパティ型定義
 * 
 * @interface processingModalProps
 * @param {boolean} open - モーダルの表示状態（true: 表示, false: 非表示）
 * @param {string} body - モーダルに表示するメッセージ内容
 */
export interface processingModalProps {
    props: {
        open: boolean,        // モーダル表示フラグ
        body: string,         // 表示メッセージ
    }
}

/**
 * 処理中モーダルコンポーネント
 * 
 * ユーザー操作を完全に無効化し、プログラムによる制御のみでモーダルの開閉を行う
 * 
 * @param {processingModalProps} props - コンポーネントのプロパティ
 * @returns {JSX.Element} ProcessingModalコンポーネント
 */
const ProcessingModal: React.FC<processingModalProps> = ({ props }) => {
    return (
        <div>
            <Dialog
                open={props.open}                                // モーダル表示状態（propsから直接取得）
                keepMounted                                      // DOMに保持（パフォーマンス向上）
                disableEscapeKeyDown                             // ESCキー無効化
                aria-describedby="processing-dialog-description" // アクセシビリティ対応
            >
                <DialogContent>
                    {/* 
                        処理中メッセージ表示
                        - whiteSpace: 'pre-wrap' で改行文字を反映
                     */}
                    <DialogContentText id="processing-dialog-description" sx={{ whiteSpace: 'pre-wrap' }}>
                        {props.body}
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </div>
    );
}

export default ProcessingModal;
